<template>
  <div>
    <div class="ibox">
      <div class="ibox-title">
        Order {{ entityOrder.uuid }}
      </div>

      <div class="ibox-content">
        <Panel :data="entityOrder"/>
      </div>
    </div>

    <template v-if="loaded">
      <div class="ibox">
        <div class="ibox-title">
          Events
          <span class="float-right mr-3" style="cursor: pointer" @click="toggleRelation('events')">
            <EyeIcon v-if="mapRelation.events.show"/>
            <EyeOffIcon v-else/>
          </span>
        </div>

        <div class="ibox-content" v-show="mapRelation.events.show">
          <Events :entityOrder="entityOrder" :currentPath="currentPath" v-if="mapRelation.events.loaded"/>
        </div>
      </div>

      <div class="ibox">
        <div class="ibox-title">
          Stages
          <span class="float-right mr-3" style="cursor: pointer" @click="toggleRelation('stages')">
            <EyeIcon v-if="mapRelation.stages.show"/>
            <EyeOffIcon v-else/>
          </span>
        </div>

        <div class="ibox-content" v-show="mapRelation.stages.show">
          <Stages :entityOrder="entityOrder" :currentPath="currentPath" v-if="mapRelation.stages.loaded"/>
        </div>
      </div>

      <div class="ibox">
        <div class="ibox-title">
          Items
          <span class="float-right mr-3" style="cursor: pointer" @click="toggleRelation('items')">
            <EyeIcon v-if="mapRelation.items.show"/>
            <EyeOffIcon v-else/>
          </span>
        </div>

        <div class="ibox-content" v-show="mapRelation.items.show">
          <Items :entityOrder="entityOrder" :currentPath="currentPath" v-if="mapRelation.items.loaded"/>
        </div>
      </div>

      <div class="ibox">
        <div class="ibox-title">
          Orders
          <span class="float-right mr-3" style="cursor: pointer" @click="toggleRelation('orders')">
            <EyeIcon v-if="mapRelation.orders.show"/>
            <EyeOffIcon v-else/>
          </span>
        </div>

        <div class="ibox-content" v-show="mapRelation.orders.show">
          <Orders :entityOrder="entityOrder" :currentPath="currentPath" v-if="mapRelation.orders.loaded"/>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ModelMapper from '@/mixins/ModelMapper'
import EntityProxy from '@/models/EntityProxy'
import Panel from '@/components/admin/maestro/Panel'

import Events from './OrderEvents.vue'
import Items from './OrderItems.vue'
import Stages from './OrderStages.vue'
import Orders from './OrderOrders.vue'

import {mapMutations} from 'vuex'
import {EyeIcon, EyeOffIcon} from 'vue-feather-icons'

export default {
  components: {Items, Events, Panel, Stages, Orders, EyeIcon, EyeOffIcon},
  computed: {
    entityOrder() {
      return EntityProxy.build(this.getModel || {})
    }
  },
  created() {
    this.asyncTemplateShow(this.id, {
      after: () => {
        this.setNameBreadcrumb(this.entityOrder.id)
        this.loaded = true
      }
    })
  },
  data: () => ({
    modelPathPrefix: 'admin',
    nameModel: 'Order',
    loaded: false,
    mapRelation: {
      events: {loaded: false, show: false},
      stages: {loaded: false, show: false},
      items: {loaded: false, show: false},
      orders: {loaded: false, show: false},
    }
  }),
  methods: {
    ...mapMutations(['setNameBreadcrumb']),
    toggleRelation(name) {
      this.mapRelation[name]['show'] = !this.mapRelation[name]['show']
      if (this.mapRelation[name]['show'])
        this.mapRelation[name]['loaded'] = true
    },
    buildPath() {
      return this.currentPath
    }
  },
  mixins: [ModelMapper],
  name: 'AdminOrdersShow',
  props: {
    id: {required: true},
    currentPath: {
      required: true,
      type: String
    }
  }
}
</script>

<style scoped>
</style>
